import Vue from "vue"
import getOnlineSalesSDK from "online-sales-sdk"

const sdk = getOnlineSalesSDK()

// 根据环境判断配置
const isProd = process.env.NODE_ENV === "production"

sdk.initialize({
  clientId: isProd ? 10110249 : 10110248,
  productAdsHost: isProd ? "ads.dfgd-os.com" : "dev-ads.dfgd-os.com",
  eventTrackingHost: isProd ? "ads.dfgd-os.com" : "dev-ads.dfgd-os.com",
  displayAdsHost: isProd ? "ads.dfgd-os.com" : "dev-ads.dfgd-os.com",
  fireDefaultPixel: false
})

Vue.prototype.$onlineSalesSdk = sdk
window.onlineSalesSdk = sdk
